module.exports = __webpack_public_path__ + "static/media/25UNHCR2.e49df292.jpg";